import React from 'react';
import { CloudOffIcon } from 'lucide-react';
interface InventoryErrorProps {
  onRetry: () => void;
}
export function InventoryError({
  onRetry
}: InventoryErrorProps) {
  return <div role="alert" className="flex flex-col items-center py-24 text-center" data-id="element-328" data-mp="2zytzo4vhs3zd">
      <CloudOffIcon className="h-10 w-10 text-muted" aria-hidden="true" data-id="element-329" data-mp="300x0ljy6nhiv" />
      <h2 className="mt-4 font-display text-2xl font-semibold text-white" data-id="element-330" data-mp="2v72i2jubd8ld">No pudimos cargar el inventario</h2>
      <p className="mt-1 max-w-sm text-sm text-muted" data-id="element-331" data-mp="39zcqjjlh4kqs">Revisá tu conexión e intentá de nuevo en unos segundos.</p>
      <button type="button" onClick={onRetry} className="mt-6 h-11 rounded-full bg-neon px-6 text-sm font-semibold text-ink shadow-neon-btn transition-colors duration-150 hover:bg-neon-bright" data-id="element-332" data-mp="350j9xiaw4dme">
        Reintentar
      </button>
    </div>;
}